module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    attrs: {
      "data-background-color": _vm.backgroundColor,
      "data-active-color": _vm.activeColor
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper",
    attrs: {
      "id": "style-3"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    class: _vm.logoClass,
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('ul', {
    class: _vm.navClasses
  }, [_vm._l((_vm.sidebarLinks), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [_c('i', {
      class: link.icon
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(link.name))])])])
  }), _vm._v(" "), _vm._m(0)], 2), _vm._v(" "), _vm._m(1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "router-link-exact-active"
  }, [_c('a', {
    attrs: {
      "href": "https://www.deliverlogic.com/npsupport/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ti-help-alt"
  }), _vm._v(" "), _c('p', [_vm._v("Support")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "powered-by"
  }, [_c('img', {
    attrs: {
      "src": "static/img/powered_by.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b41be7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/SideBar.vue
// module id = 375
// module chunks = 1